import { useState, useEffect } from 'react'
import { datesLoader } from '../apiCalls'
import { Link } from 'react-router-dom'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Button from 'react-bootstrap/Button'
import Stack from 'react-bootstrap/Stack'
import NewDate from './newDate'

function DateList (props) {
    const [dates, setDates] = useState([])
    const [dateFormToggle, setDateFormToggle] = useState(false)
    
    async function getDates() {
        try{
            let myDates = await datesLoader();
            setDates(myDates)
        } catch(err) {
            console.log(err)
        }
    }
    
    function buildList() {
        const dateArr = dates.map((value, idx) => {
            return(
                <div key={idx} className="dateContainer">
                    <Link to={`/dates/${value._id}`}>
                        <Row>
                            <Col>
                                <h3>{value.name}</h3>
                                <p>Location: {value.location}</p>
                            </Col>
                        </Row>
                    </Link>
                </div>
            )
        })

        return dateArr
    }
    // Placeholder for dateList api
    useEffect(() => {
        getDates()
    }, []);
    
    function handleNewDate() {
        setDateFormToggle(true)
    }

    return(
        <>
        <Row className="dateButtonDiv">
            <Col>
                <Button className="btn-dark defaultButton dateButton" onClick={handleNewDate}>New Date</Button>
            </Col>
        </Row>
        {dateFormToggle ? <NewDate mods={{setDateFormToggle, getDates}} /> : null}
        <Stack gap={3} className="listStack">
            {dates.length ? buildList() : <h4 className="dateContainer">No dates scheduled.</h4>}
        </Stack>
        </>
    )
}

export default DateList